import React, {useState} from 'react'
import {useSearchParams} from 'react-router-dom';
import {Flex, Spin} from 'antd';
import Filter from "./filter";
import cls from "classnames";
import {
  ClockCircleOutlined, CoffeeOutlined,
  LineChartOutlined, LogoutOutlined,
  MinusCircleOutlined
} from "@ant-design/icons";
import {get} from "lodash";
import UniversalCollapse from "./universalCollapse";
import {getCurrentMonthRange} from "../../utils/dateHelpers";
import {useQuery} from "@tanstack/react-query";
import axiosInstance, {endpoints} from "../../services/axios";
import {iDate, iDS} from "../../models";

const EmployeeAttendance = () => {
  const [searchParams] = useSearchParams();
  const [{toDate, fromDate}, setPeriod] = useState<iDate>(getCurrentMonthRange());
  const [{companyIds, departmentIds}, setIds] = useState<iDS>({companyIds: [], departmentIds: []});

  const {data: formData, isFetching: filterFetching} = useQuery({
    queryKey: ["employee-attendance", toDate, fromDate, companyIds, departmentIds],
    queryFn: async () => {
      axiosInstance.defaults.headers.common.Authorization = searchParams.get("token");
      return await axiosInstance.get(endpoints.employeeAttendance.list(fromDate, toDate, companyIds, departmentIds));
    },
    enabled: !!fromDate || !!toDate
  });

  const data = get(formData, "data.data", {});

  const colors = (percent: number) => {
    if (percent >= 95) return 'text-primary';
    if (percent >= 80) return 'text-orange-400';
    return 'text-red-500';
  }

  if (filterFetching) {
    return <div className="w-full min-h-screen flex justify-center items-center"><Spin tip="Loading"
                                                                                       size="large"></Spin></div>
  }

  return (
      <div>
        <Flex className="justify-between items-center">
          <p className=" text-xl font-bold text-gray-600">Xodimlar Davomat Paneli</p>
          <Filter setPeriod={setPeriod} setIds={setIds}/>
        </Flex>
        <Flex className="pb-2" justify="space-between" gap={20}>
          <Flex
              vertical align="center"
              gap={10} style={{border: "1px solid #D1D5DB"}}
              className="relative w-full overflow-hidden rounded-md"
          >
            <p className={cls(colors(get(data, 'disciplinePercent')), 'text-3xl font-bold text-orange-400')}>{get(data, 'disciplinePercent')}%</p>
            <Flex gap={10} className="text-gray-600">
              <LineChartOutlined className={cls(colors(get(data, 'disciplinePercent')), 'text-xl text-orange-400')}/>
              <p>Umumiy intizom</p>
            </Flex>
            <div className="absolute bottom-0 w-full bg-gray-200">
              <div style={{width: `${get(data, 'disciplinePercent')}%`}}
                   className={cls(
                       get(data, 'disciplinePercent') > 95 ? 'bg-primary'
                           : get(data, 'disciplinePercent') > 80 ? 'bg-orange-400' : 'bg-red-500', `py-1`,
                   )}
              ></div>
            </div>
          </Flex>
          <Flex
              vertical align="center"
              gap={10} style={{border: "1px solid #D1D5DB"}}
              className="w-full rounded-md"
          >
            <p className="text-primary text-3xl font-bold">{get(data, 'lateArriveCount')}</p>
            <Flex gap={10} className="text-gray-600">
              <ClockCircleOutlined className="text-primary text-xl"/>
              <p>Kechikishlar soni</p>
            </Flex>
          </Flex>
          <Flex
              vertical align="center"
              gap={10} style={{border: "1px solid #D1D5DB"}}
              className="w-full rounded-md "
          >
            <p className="text-primary text-3xl font-bold">{get(data, 'earlyLeaveCount')}</p>
            <Flex gap={10} className="text-gray-600">
              <LogoutOutlined className="text-primary text-xl"/>
              <p>Erta ketishlar</p>
            </Flex>
          </Flex>
          <Flex
              vertical align="center"
              gap={10} style={{border: "1px solid #D1D5DB"}}
              className="w-full rounded-md"
          >
            <p className="text-primary text-3xl font-bold">{get(data, 'overBreakCount')}</p>
            <Flex gap={10} className="text-gray-600">
              <CoffeeOutlined className="text-primary text-xl"/>
              <p>Uzoq tanaffuslar</p>
            </Flex>
          </Flex>
          <Flex
              vertical align="center"
              gap={10} style={{border: "1px solid #D1D5DB"}}
              className="w-full rounded-md"
          >
            <p className="text-primary text-3xl font-bold">{get(data, 'absenceCount')}</p>
            <Flex gap={10} className="text-gray-600">
              <MinusCircleOutlined className="text-primary text-xl"/>
              <p>Kelmaganlar</p>
            </Flex>
          </Flex>
        </Flex>

        <Flex
            justify="space-between" style={{border: "1px solid #D1D5DB"}}
            className="sticky top-0 z-10 rounded-t-2xl bg-white py-4 "
        >
          <p className="w-[250%] pl-3 text-sm font-bold">Bo'lim</p>
          <p className="w-full text-center text-sm font-bold">Intizomi</p>
          <p className="w-full text-center text-sm font-bold">Kechikishlar</p>
          <p className="w-full text-center text-sm font-bold">Erta ketishlar </p>
          <p className="w-full text-center text-sm font-bold">Uzoq tanaffuslar</p>
          <p className="w-full text-center text-sm font-bold">Kelmaganlar</p>
        </Flex>

        {data && <UniversalCollapse data={data.departmentAttendances}/>}
      </div>
  )
}
export default EmployeeAttendance